import React, { PureComponent } from "react";

import numeral from "numeral";
import moment from "moment";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Toggle from "react-toggle";

import { isEnabled } from "utils/featureFlags";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import CrownIcon from "images/CrownIcon.svg";
import LightningBoltIcon from "images/lightningbolt.svg";

import MaxProfit from "images/MaxProfit.svg";
import MaxRevenue from "images/MaxRevenue.svg";
import MinResource from "images/MinResource.svg";
import MaxAccuracy from "images/MaxAccuracy.svg";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import FunnelTooltip from "components/Business/ModelBox/FunnelTooltip";
import FakeMonitorGraph from "components/Consumer/FakeMonitorGraph";
import MonitoringSparkGraphContainer from "containers/Monitoring/MonitoringSparkGraph";

import ComplianceGraphContainer from "containers/Monitoring/ComplianceGraph";
import ModelFeedbackContainer from "containers/Business/ModelBox/ModelFeedback";

import styles from "./style.module.css";

export default class ModelBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { displayHoverContent: false };
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  getNewFunnelValue(oldValue, oldMax) {
    return ((oldValue - 0) * (300 - 0)) / (oldMax - 0) + 0;
  }

  renderOverview() {
    const {
      id,
      projectId,
      mode,
      optimized,
      isConsumer,
      data,
      model,
      modelGroups,
      setupLabels,
      overallSetup,
      updateShowImpact,
      updateDrilldownValue,
      businessAssumptions,
      scrollToRealityHammer,
      showFeedback
    } = this.props;

    const rawRunId = this.props.runId;

    const allDriversAdded =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter(
        (group) => group && group.setup && group.column !== "Overall" && !group.setup.showImpact
      ).length === 0;

    const overallOnly = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length < 2;

    const cSetup = optimized && optimized.setup ? optimized.setup : undefined;

    let setup = overallSetup ? overallSetup : cSetup;
    let normalizeSetup = setup;
    if (isConsumer) {
      let largestSetup = undefined;
      modelGroups &&
        modelGroups.drilldownValues &&
        modelGroups.drilldownValues.length > 1 &&
        modelGroups.drilldownValues.forEach((group) => {
          if (group && group.column !== "Overall") {
            const currSetup = group.setup;
            const currTotal = currSetup
              ? currSetup.truePositive + currSetup.falsePositive + currSetup.trueNegative + currSetup.falseNegative
              : 0;
            const oldTotal = largestSetup
              ? largestSetup.truePositive +
                largestSetup.falsePositive +
                largestSetup.trueNegative +
                largestSetup.falseNegative
              : 0;
            if (currTotal > oldTotal) {
              largestSetup = currSetup;
            }
          }
        });
      if (largestSetup) {
        normalizeSetup = largestSetup;
      }
    }

    const runId = data && data.runId;

    const sliceSetup = data && data.setup;

    const activeSlice =
      data &&
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === data.runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === data.runId)[0]
        : undefined;

    const activeColor = activeSlice ? activeSlice.color : "#7E69D7";

    const winRate =
      activeSlice && activeSlice.ccm ? activeSlice.ccm.tp / (setup.truePositive + setup.falsePositive) : 0;
    const cWinRate = setup ? setup.truePositive / (setup.truePositive + setup.falsePositive) : 0;

    const cTotal = setup ? setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative : 0;
    const nTotal =
      activeSlice && activeSlice.ccm
        ? activeSlice.ccm.tp + activeSlice.ccm.fp + activeSlice.ccm.tn + activeSlice.ccm.fn
        : 0;
    const funnelTotal = normalizeSetup
      ? normalizeSetup.truePositive +
        normalizeSetup.falsePositive +
        normalizeSetup.trueNegative +
        normalizeSetup.falseNegative
      : 0;

    const oldMax = Math.max(funnelTotal, nTotal);

    const cLeads = this.getNewFunnelValue(funnelTotal, oldMax);
    const cOpps = this.getNewFunnelValue(setup.truePositive + setup.falsePositive, oldMax);
    const cWins = this.getNewFunnelValue(setup.truePositive, oldMax);
    const nLeads = this.getNewFunnelValue(nTotal, oldMax);
    const nOpps = this.getNewFunnelValue(
      activeSlice && activeSlice.ccm ? activeSlice.ccm.tp + activeSlice.ccm.fp : 0,
      oldMax
    );
    const nWins = this.getNewFunnelValue(activeSlice && activeSlice.ccm ? activeSlice.ccm.tp : 0, oldMax);

    const unitType = setup.unitType ? setup.unitType : "$";

    /*const isEmpty =
      cSetup.showImpact === undefined && cSetup.showBusiness === undefined;
    const isPercentage =
      cSetup.showImpact === undefined && cSetup.showBusiness === true;*/

    const isEmpty = isConsumer ? false : sliceSetup.showImpact === undefined && sliceSetup.showBusiness === undefined;
    const isPercentage = isConsumer ? false : sliceSetup.showImpact === undefined && sliceSetup.showBusiness === true;

    const cEffort = ((setup.truePositive + setup.falsePositive) / cTotal) * 100;

    const nEffort = activeSlice && activeSlice.ccm ? ((activeSlice.ccm.tp + activeSlice.ccm.fp) / nTotal) * 100 : 0;

    const handleUpdateImpact = async () => {
      await updateShowImpact(runId, true);
      if (runId) {
        updateDrilldownValue(data.runId, data.value);
        if (scrollToRealityHammer) {
          scrollToRealityHammer();
        }
      }
    };

    const costDelta = activeSlice ? activeSlice.cost - activeSlice.currentCost : 0;

    const profitDelta = activeSlice ? activeSlice.profit - activeSlice.currentProfit : 0;

    const revenueDelta = activeSlice ? activeSlice.revenue - activeSlice.currentRevenue : 0;

    const profitDiffLabel = `${profitDelta > 0 ? "+" : "-"} ${
      setupLabels.unitType
    }${numeral(Math.abs(profitDelta)).format("0.0a")}`;

    const revenueDiffLabel = `${revenueDelta > 0 ? "+" : "-"} ${
      setupLabels.unitType
    }${numeral(Math.abs(revenueDelta)).format("0.0a")}`;

    return (
      <div className={styles.sContent}>
        <div className={styles.fullColumn}>
          {!optimized || optimized.isCreating ? (
            <div className={styles.funnelLoading}>
              <LoadingIndicator style={{ margin: "0px" }} />
            </div>
          ) : (
            <React.Fragment />
          )}
          {showFeedback && isConsumer && (
            <div className={styles.feedbackWrapper}>
              <ModelFeedbackContainer runId={rawRunId} projectId={projectId} optimized={optimized} />
            </div>
          )}
          <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                  </span>
                  {nTotal}
                </div>
              }
            >
              <div
                className={styles.modelBar}
                style={{
                  width: nLeads + "px",
                  background: activeColor,
                  opacity: 0.6
                }}
              />
            </FunnelTooltip>
            {mode === "MONITOR" && <div className={styles.monitorBar} style={{ width: "50%" }} />}
          </div>
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "700" }}>
                  {setupLabels ? setupLabels.notPursuedTransactionLabel + " " + setupLabels.falseAction + ": " : ""}
                </span>
                {activeSlice && activeSlice.ccm ? activeSlice.ccm.tn + activeSlice.ccm.fn : ""}
              </div>
            }
          >
            <div className={styles.modelBarHolder}>
              <div
                className={styles.modelBar}
                style={{
                  width: nLeads + "px",
                  borderLeft: (nLeads - nOpps) / 2 + "px solid transparent",
                  borderRight: (nLeads - nOpps) / 2 + "px dotted transparent",
                  borderTop: " 40px solid " + activeColor,
                  opacity: 0.2
                }}
              />
            </div>
          </FunnelTooltip>
          <div className={styles.modelBarHolder}>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {"Total " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                  </span>
                  {activeSlice && activeSlice.ccm ? activeSlice && activeSlice.ccm.tp + activeSlice.ccm.fp : ""}
                </div>
              }
            >
              <div
                className={styles.modelBar}
                style={{
                  width: nOpps + "px",
                  background: activeColor,
                  opacity: 0.8
                }}
              />
            </FunnelTooltip>
            {mode === "MONITOR" && <div className={styles.monitorBar} style={{ width: "30%" }} />}
          </div>
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "700" }}>
                  {(setupLabels ? setupLabels.transactionLabel : "") +
                    " not " +
                    (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                </span>
                {activeSlice && activeSlice.ccm ? activeSlice.ccm.fp : ""}
              </div>
            }
          >
            <div className={styles.modelBarHolder}>
              <div
                className={styles.modelBar}
                style={{
                  width: nOpps + "px",
                  borderLeft: (nOpps - nWins) / 2 + "px solid transparent",
                  borderRight: (nOpps - nWins) / 2 + "px dotted transparent",
                  borderTop: "40px solid " + activeColor,
                  opacity: 0.3
                }}
              />
            </div>
          </FunnelTooltip>

          <div className={styles.modelBarHolder}>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                  </span>
                  {activeSlice && activeSlice.ccm ? activeSlice.ccm.tp : ""}
                </div>
              }
            >
              <div className={styles.modelBar} style={{ width: nWins + "px", background: activeColor }} />
            </FunnelTooltip>
            {mode === "MONITOR" && <div className={styles.monitorBar} style={{ width: "10%" }} />}
          </div>
          {
            /*optimized && optimized.bestModel && isEmpty ? (
            <div
              className={styles.sEmpty}
              style={{ marginTop: "14px", paddingTop: "14px", height: "54psx" }}
            >
              {"Add business objectives to see the optimized effort"}
            </div>
          ) : */

            optimized && optimized.bestModel && (isPercentage || isEmpty) ? (
              <div className={styles.sInfo} style={{ marginTop: "14px", paddingTop: "14px", height: "54px" }}>
                <span className={styles.mLarge}>{nEffort.toFixed(2) + "%"}</span>
                <span className={styles.mMedium}>
                  {(nEffort > cEffort ? "+" : "-") + "(" + Math.abs(nEffort - cEffort).toFixed(2) + "%)"}
                </span>
              </div>
            ) : optimized && optimized.bestModel ? (
              <div className={styles.sInfo} style={{ marginTop: "14px", paddingTop: "14px", height: "54px" }}>
                <span className={styles.mLarge}>
                  {unitType + (activeSlice ? numeral(activeSlice.cost).format("0.0a") : "")}
                </span>
                <span className={styles.mMedium}>
                  {`${costDelta > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(Math.abs(costDelta)).format("0.0a")}`}
                </span>
              </div>
            ) : optimized ? (
              <LoadingIndicator style={{ margin: "0px" }} />
            ) : (
              <div />
            )
          }
          {optimized && optimized.bestModel && (isPercentage || isEmpty) ? (
            <div className={styles.sInfo} style={{ marginTop: "10px", paddingTop: "10px", height: "50px" }}>
              <span className={styles.mLarge}>{(winRate * 100).toFixed(2) + "%"}</span>
              <span className={styles.mMedium}>
                {(winRate * 100 > cWinRate * 100 ? "+" : "-") +
                  "(" +
                  Math.abs(winRate * 100 - cWinRate * 100).toFixed(2) +
                  "%)"}
              </span>
            </div>
          ) : optimized && optimized.bestModel ? (
            <div
              className={styles.sInfo}
              style={{
                marginTop: "10px",
                height: "50px"
              }}
            >
              <span className={styles.mLarge}>
                {unitType + (activeSlice ? numeral(activeSlice.revenue).format("0.0a") : "")}
              </span>
              <span className={styles.mMedium}>{revenueDiffLabel}</span>
            </div>
          ) : optimized ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <div />
          )}
          {businessAssumptions ? null : optimized && optimized.bestModel ? (
            isPercentage === true || isEmpty === true ? (
              <a
                className={styles.sEmpty}
                style={{
                  marginTop: "10px",
                  paddingTop: "10px",
                  height: "50px",
                  fontSize: "13px",
                  color: "#7E69D7"
                }}
                onClick={() => {
                  handleUpdateImpact();
                }}
              >
                <img src={LightningBoltIcon} className={styles.lightningIcon} />
                {`Review to optimize profit`}
              </a>
            ) : (
              <div
                className={styles.sInfo}
                style={{
                  marginTop: "10px",
                  paddingTop: "10px",
                  height: "50px"
                }}
              >
                <span className={styles.mLarge}>
                  {unitType + (activeSlice ? numeral(activeSlice.profit).format("0.0a") : "")}
                </span>
                <span className={styles.mMedium}>{profitDiffLabel}</span>
                {/*
              <span className={styles.mMedium}>
                {" "}
                {optimized.profitDelta > 0
                  ? "+(" +
                    (
                      ((optimized.profit - optimized.currentProfit) /
                        optimized.profit) *
                      100
                    ).toFixed(1) +
                    "%)"
                  : "-(" +
                    (
                      ((optimized.currentProfit - optimized.profit) /
                        optimized.currentProfit) *
                      100
                    ).toFixed(1) +
                    "%)"}
              </span>
              */}
              </div>
            )
          ) : optimized ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  getMaxAccuracy(models) {
    return Math.max.apply(
      Math,
      models.map((m) => m.maxIteration.accuracy)
    );
  }

  getMinAccuracy(models) {
    return Math.min.apply(
      Math,
      models.map((m) => m.maxIteration.accuracy)
    );
  }

  getMaxRevenue(models) {
    const { data } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) => m.maxIteration.truePositive * data.setup.conversionGain)
    );
  }

  getMinRevenue(models) {
    const { data } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) => m.maxIteration.truePositive * data.setup.conversionGain)
    );
  }

  getMaxCost(models) {
    const { data } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) =>
        Math.abs((m.maxIteration.truePositive + m.maxIteration.falsePositive) * data.setup.conversionCost)
      )
    );
  }

  getMinCost(models) {
    const { data } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) =>
        Math.abs((m.maxIteration.truePositive + m.maxIteration.falsePositive) * data.setup.conversionCost)
      )
    );
  }

  getMinImpact(models) {
    const { data } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) => m.roi)
    );
  }

  getMaxImpact(models) {
    const { data } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) => m.roi)
    );
  }

  getNewValue(oldValue, oldMin, oldMax) {
    return ((oldValue - oldMin) * (100 - 0)) / (oldMax - oldMin) + 0;
  }

  renderModel(hideBadge = false) {
    const {
      data,
      color,
      model,
      isContinuous,
      hideBest,
      modelIsAllowedInFrontier,
      setIsAllowedInFrontier,
      updateIgnoredModel,
      showExcludeToggle,
      setupLabels,
      enableHoverNavigation,
      viewTestPredictions,
      isConsumer,
      sortMode
    } = this.props;

    if (data.modelList === undefined) {
      return <div />;
    }

    const maxRevenue = this.getMaxRevenue(data.modelList);
    const minRevenue = this.getMinRevenue(data.modelList);

    const sameRevModels =
      data && data.modelList
        ? data.modelList.every((m) => {
            return (
              m.maxIteration.truePositive * data.setup.conversionGain ===
              model.maxIteration.truePositive * data.setup.conversionGain
            );
          })
        : false;

    const nRevenue = sameRevModels
      ? 100
      : this.getNewValue(model.maxIteration.truePositive * data.setup.conversionGain, minRevenue, maxRevenue);

    const sameCostModels =
      data && data.modelList
        ? data.modelList.every((m) => {
            return (
              m.maxIteration.truePositive + m.maxIteration.falsePositive ===
              model.maxIteration.truePositive + model.maxIteration.falsePositive
            );
          })
        : false;

    const sameImpactModels =
      data && data.modelList
        ? data.modelList.every((m) => {
            return m.roi === model.roi;
          })
        : false;

    const mRevenue = model.maxIteration.truePositive * data.setup.conversionGain;
    const mCost = Math.abs(
      (model.maxIteration.truePositive + model.maxIteration.falsePositive) * data.setup.conversionCost
    );

    const nCost = sameCostModels
      ? 100
      : this.getNewValue(
          Math.abs((model.maxIteration.truePositive + model.maxIteration.falsePositive) * data.setup.conversionCost),
          this.getMinCost(data.modelList),
          this.getMaxCost(data.modelList)
        );

    const nImpact = sameImpactModels
      ? 100
      : this.getNewValue(model.roi, this.getMinImpact(data.modelList), this.getMaxImpact(data.modelList));

    const unitType = setupLabels && setupLabels.unitType ? setupLabels.unitType : "";

    const decideHeaderColor = () => {
      if (!modelIsAllowedInFrontier) {
        return { background: "#d3d3d3" };
      }

      if (data && data.column === "Overall") {
        return { background: "#7E69D7", color: "white" };
      }

      return color ? { background: color } : data && data.color ? { background: data.color } : {};
    };

    const onHover = (display = false) => {
      if (!enableHoverNavigation) {
        return;
      }
      if (this.state.displayHoverContent !== display) {
        this.setState({ displayHoverContent: display });
      }
    };

    let badges = [];

    if (hideBadge === false && model.isMaxProfit && hideBest !== true) {
      badges.push(
        <div className={styles.sModelBadgeHolder}>
          <img src={CrownIcon} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Optimal"}</div>
        </div>
      );
    }

    if (hideBadge === false && model.isMaxRevenue) {
      badges.push(
        <div className={styles.sModelBadgeHolder} style={{ background: data.colorSecondary }}>
          <img src={MaxRevenue} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Max Revenue"}</div>
        </div>
      );
    }

    if (hideBadge === false && model.isMinResource) {
      badges.push(
        <div className={styles.sModelBadgeHolder} style={{ background: data.colorSecondary }}>
          <img src={MinResource} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Min Resource"}</div>
        </div>
      );
    }

    if (hideBadge === false && model.isMaxAccuracy) {
      badges.push(
        <div className={styles.sModelBadgeHolder} style={{ background: data.colorSecondary }}>
          <img src={MaxAccuracy} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Max Accuracy"}</div>
        </div>
      );
    }

    if (hideBadge === false && model.isMaxPrecision) {
      badges.push(
        <div className={styles.sModelBadgeHolder} style={{ background: data.colorSecondary }}>
          <img src={MaxAccuracy} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Max Precision"}</div>
        </div>
      );
    }

    if (hideBadge === false && model.isMaxRecall) {
      badges.push(
        <div className={styles.sModelBadgeHolder} style={{ background: data.colorSecondary }}>
          <img src={MaxAccuracy} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Max Recall"}</div>
        </div>
      );
    }

    if (hideBadge === false && model.isMinLogLoss) {
      badges.push(
        <div className={styles.sModelBadgeHolder} style={{ background: data.colorSecondary }}>
          <img src={MaxAccuracy} className={styles.sModelIcon} />
          <div className={styles.sOpt}>{"Min Log Loss"}</div>
        </div>
      );
    }

    return (
      <div
        className={styles.modelContent}
        onMouseEnter={() => onHover(true)}
        onMouseLeave={() => onHover(false)}
        style={hideBadge === true ? { height: "auto" } : {}}
      >
        <div
          className={styles.sModelHeader}
          style={{
            ...decideHeaderColor(),
            height: hideBadge === true ? "50px" : "180px"
          }}
        >
          <div className={styles.hTop}>
            {sortMode === "PROFIT" || isContinuous
              ? `${unitType}${numeral(model ? (isContinuous ? Math.abs(model.roi) : model.roi) : 0).format("0.0a")}`
              : sortMode === "REVENUE"
                ? `${unitType}${numeral(
                    model && model.maxIteration
                      ? model.maxIteration.totalWins *
                          (Number(data.setup.conversionGain) + Math.abs(Number(data.setup.conversionCost)))
                      : 0
                  ).format("0.0a")}`
                : sortMode === "ACCURACY"
                  ? model && model.maxIteration
                    ? (model.maxIteration.accuracy * 100).toFixed(2) + "%"
                    : 0
                  : sortMode === "PRECISION"
                    ? model && model.maxIteration
                      ? (model.maxIteration.precision * 100).toFixed(2) + "%"
                      : 0
                    : sortMode === "RECALL"
                      ? model && model.metadata
                        ? (model.metadata.recall_score * 100).toFixed(2) + "%"
                        : 0
                      : sortMode === "LOGLOSS"
                        ? model && model.metadata
                          ? model.metadata.log_loss.toFixed(2)
                          : 0
                        : sortMode === "RESOURCING"
                          ? `${unitType}${numeral(
                              model && model.maxIteration
                                ? (model.maxIteration.truePositive + model.maxIteration.falsePositive) *
                                    Math.abs(Number(data.setup.conversionCost))
                                : 0
                            ).format("0.0a")}`
                          : `${unitType}${numeral(model ? model.roi : 0).format("0.0a")}`}
          </div>
          <div className={styles.badgeHolder} style={badges.length === 1 ? { justifyContent: "center" } : {}}>
            {badges}
          </div>
          {hideBadge === false && <div className={styles.hBot}>{model ? model.label : ""}</div>}
        </div>
        {this.renderFeedback()}
        <div className="modelMainContent">
          <React.Fragment>
            {/*hideBadge === false && (
                <div className={styles.modelBot}>
                  <div className={styles.mSubTitle}>{"Growth Over Profit"}</div>
                  <div>{"I help prioritize growing your business"}</div>
                </div>
              )*/}

            {isContinuous !== true && (
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                  <Popover id={"popover-positioned-top"}>
                    <div className={styles.mTooltip}>
                      <div className={styles.mLeft}>{setupLabels.revenueLabel}</div>
                      <div className={styles.mRight}>{unitType + numeral(mRevenue).format("0.0a")}</div>
                    </div>
                  </Popover>
                }
              >
                <div className={styles.sModelInfo} style={{ marginTop: "10px", fontSize: "12px" }}>
                  <div className={styles.infoType}>{setupLabels.revenueLabel}</div>
                  <div className={styles.infoBar}>
                    <div className={styles.filledBar} style={{ width: nRevenue + "%" }} />
                  </div>
                  <div className={styles.infoScore}>{nRevenue >= 80 ? "High" : nRevenue >= 45 ? "Medium" : "Low"}</div>
                </div>
              </OverlayTrigger>
            )}
            {isContinuous !== true && (
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                  <Popover id={"popover-positioned-top"}>
                    <div className={styles.mTooltip}>
                      <div className={styles.mLeft}>{setupLabels.costLabel}</div>
                      <div className={styles.mRight}>{unitType + numeral(mCost).format("0.0a")}</div>
                    </div>
                  </Popover>
                }
              >
                <div className={styles.sModelInfo} style={{ marginTop: "20px", fontSize: "12px" }}>
                  <div className={styles.infoType}>{setupLabels.costLabel}</div>
                  <div className={styles.infoBar}>
                    <div className={styles.filledBar} style={{ width: nCost + "%" }} />
                  </div>
                  <div className={styles.infoScore}> {nCost >= 80 ? "High" : nCost >= 45 ? "Medium" : "Low"}</div>
                </div>
              </OverlayTrigger>
            )}
            <OverlayTrigger
              placement={"top"}
              trigger={["hover", "focus"]}
              overlay={
                <Popover id={"popover-positioned-top"}>
                  <div className={styles.mTooltip}>
                    <div className={styles.mLeft}>{setupLabels.profitLabel}</div>
                    <div className={styles.mRight}>{unitType + numeral(model.roi).format("0.0a")}</div>
                  </div>
                </Popover>
              }
            >
              <div className={styles.sModelInfo} style={{ marginTop: "20px", fontSize: "12px" }}>
                <div className={styles.infoType}>{setupLabels.profitLabel}</div>
                <div className={styles.infoBar}>
                  <div className={styles.filledBar} style={{ width: nImpact + "%" }} />
                </div>
                <div className={styles.infoScore}>{nImpact >= 80 ? "High" : nImpact >= 45 ? "Medium" : "Low"}</div>
              </div>
            </OverlayTrigger>
            {isContinuous ? (
              <div />
            ) : sortMode === "RECALL" ? (
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                  <Popover id={"popover-positioned-top"}>
                    <div className={styles.mTooltip}>
                      <div className={styles.mLeft}>{"Recall"}</div>
                      <div className={styles.mRight}>{(model.metadata.recall_score * 100).toFixed(2) + "%"}</div>
                    </div>
                  </Popover>
                }
              >
                <div className={styles.sModelInfo} style={{ marginTop: "20px", fontSize: "12px" }}>
                  <div className={styles.infoType}>{"Recall"}</div>
                  <div className={styles.infoBar}>
                    <div
                      className={styles.filledBar}
                      style={{
                        width: model ? model.metadata.recall_score * 100 + "%" : "0%"
                      }}
                    />
                  </div>
                  <div className={styles.infoScore}>
                    {model
                      ? model.metadata.recall_score * 100 >= 80
                        ? "High"
                        : model.metadata.recall_score * 100 >= 45
                          ? "Medium"
                          : "Low"
                      : "Low"}
                  </div>
                </div>
              </OverlayTrigger>
            ) : sortMode === "PRECISION" ? (
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                  <Popover id={"popover-positioned-top"}>
                    <div className={styles.mTooltip}>
                      <div className={styles.mLeft}>{"Precision"}</div>
                      <div className={styles.mRight}>{(model.metadata.precision_score * 100).toFixed(2) + "%"}</div>
                    </div>
                  </Popover>
                }
              >
                <div className={styles.sModelInfo} style={{ marginTop: "20px", fontSize: "12px" }}>
                  <div className={styles.infoType}>{"Precision"}</div>
                  <div className={styles.infoBar}>
                    <div
                      className={styles.filledBar}
                      style={{
                        width: model ? model.metadata.precision_score * 100 + "%" : "0%"
                      }}
                    />
                  </div>
                  <div className={styles.infoScore}>
                    {model
                      ? model.metadata.precision_score * 100 >= 80
                        ? "High"
                        : model.metadata.precision_score * 100 >= 45
                          ? "Medium"
                          : "Low"
                      : "Low"}
                  </div>
                </div>
              </OverlayTrigger>
            ) : sortMode === "LOGLOSS" ? (
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                  <Popover id={"popover-positioned-top"}>
                    <div className={styles.mTooltip}>
                      <div className={styles.mLeft}>{"Log Loss"}</div>
                      <div className={styles.mRight}>{model.metadata.log_loss.toFixed(2)}</div>
                    </div>
                  </Popover>
                }
              >
                <div className={styles.sModelInfo} style={{ marginTop: "20px", fontSize: "12px" }}>
                  <div className={styles.infoType}>{"Log Loss"}</div>
                  <div className={styles.infoBar}>
                    <div
                      className={styles.filledBar}
                      style={{
                        width: model ? model.metadata.log_loss * 100 + "%" : "0%"
                      }}
                    />
                  </div>
                  <div className={styles.infoScore}>
                    {model
                      ? model.metadata.log_loss * 100 >= 80
                        ? "High"
                        : model.metadata.log_loss * 100 >= 45
                          ? "Medium"
                          : "Low"
                      : "Low"}
                  </div>
                </div>
              </OverlayTrigger>
            ) : (
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                  <Popover id={"popover-positioned-top"}>
                    <div className={styles.mTooltip}>
                      <div className={styles.mLeft}>{"Accuracy"}</div>
                      <div className={styles.mRight}>{(model.maxIteration.accuracy * 100).toFixed(2) + "%"}</div>
                    </div>
                  </Popover>
                }
              >
                <div className={styles.sModelInfo} style={{ marginTop: "20px", fontSize: "12px" }}>
                  <div className={styles.infoType}>{"Accuracy"}</div>
                  <div className={styles.infoBar}>
                    <div
                      className={styles.filledBar}
                      style={{
                        width: model ? model.maxIteration.accuracy * 100 + "%" : "0%"
                      }}
                    />
                  </div>
                  <div className={styles.infoScore}>
                    {model
                      ? model.maxIteration.accuracy * 100 >= 80
                        ? "High"
                        : model.maxIteration.accuracy * 100 >= 45
                          ? "Medium"
                          : "Low"
                      : "Low"}
                  </div>
                </div>
              </OverlayTrigger>
            )}
          </React.Fragment>
        </div>
        {this.state.displayHoverContent && (
          <div className={styles.actionsHolder}>
            {showExcludeToggle && (
              <div className={styles.allowFrontierHolder}>
                <span>Exclude</span>
                <Toggle
                  checked={!modelIsAllowedInFrontier}
                  onChange={() => {
                    if (model) {
                      setIsAllowedInFrontier(model.id, !modelIsAllowedInFrontier);
                      updateIgnoredModel(model.id, modelIsAllowedInFrontier);
                    }
                  }}
                />
              </div>
            )}
            <div className={styles.innerActions}>
              <Button
                style={{ padding: "2px" }}
                onClick={() =>
                  viewTestPredictions({
                    value: model,
                    subgroup: { runId: data.runId, value: data.value }
                  })
                }
              >
                {`View & Test`}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderDetails(hideTitle = false) {
    const { modelGroups, data, color, model, modelIsAllowedInFrontier, isConsumer, modelTopDrivers } = this.props;

    if (modelGroups === undefined) {
      return <div />;
    }

    const topDrivers =
      modelGroups.topDrivers && modelGroups.topDrivers.length > 0 ? modelGroups.topDrivers[0] : undefined;

    const count = 5;

    const showValues = true;

    const decideHeaderColor = () => {
      if (!modelIsAllowedInFrontier) {
        return { background: "#d3d3d3" };
      }

      if (data && data.column === "Overall") {
        return { background: "#7E69D7", color: "white" };
      }

      return color ? { background: color } : data && data.color ? { background: data.color } : {};
    };

    return (
      <div className={styles.mContentDetails}>
        {hideTitle === false && (
          <div className={styles.sTitle} style={decideHeaderColor()}>
            {model.label}
          </div>
        )}
        <div className={styles.mSubTitle + " " + (isConsumer ? styles.isConsumer : "")}>{"Key Drivers"}</div>
        {modelTopDrivers &&
          modelTopDrivers
            .filter((m, i) => i < count)
            .map((m, i) => (
              <div
                className={
                  styles.driverWrapper +
                  " " +
                  (showValues ? styles.hasValues : "") +
                  " " +
                  (isConsumer ? styles.isConsumer : "")
                }
                key={i + m.field}
              >
                <div className={styles.driverTitle + " " + (showValues ? "" : styles.hideValues)}>{m.field}</div>
                {showValues ? (
                  <React.Fragment>
                    {m.maxName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.increase}>
                          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleUp} />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.maxName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {m.minName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.decrease}>
                          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleDown} />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.minName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            ))}
      </div>
    );
  }

  renderFeedback() {
    const { modelGroups, data, color, model, isConsumer, updateModelFeedback, userId } = this.props;

    const segment =
      data && data.segment
        ? data.segment
        : modelGroups &&
          modelGroups.segments &&
          modelGroups.segments.find((seg) => data && seg && seg.job && seg.job.job_id === data.runId);

    const modelId = model && model.id;
    let userFeedback = 0;
    const feedbackCount =
      segment && segment.roles
        ? segment.roles.reduce((a, b) => {
            const currPref =
              b && b.preferences && b.preferences.feedback && b.preferences.feedback[modelId] !== undefined
                ? Number(b.preferences.feedback[modelId])
                : 0;
            if (b && b.role_user && b.role_user.id === Number(userId)) {
              userFeedback = currPref;
            }
            return a + currPref;
          }, 0)
        : 0;

    return (
      <div className={styles.eFeedBack + " " + (isConsumer ? styles.isConsumer : "")}>
        <ButtonGroup>
          <Button
            onClick={modelId ? () => updateModelFeedback(data && data.runId, modelId, true) : () => {}}
            active={userFeedback === 1}
            style={{ padding: "5px" }}
          >
            <FontAwesomeIcon icon={faThumbsUp} />
          </Button>
          <Button
            onClick={modelId ? () => updateModelFeedback(data && data.runId, modelId, false) : () => {}}
            active={userFeedback === -1}
            style={{ padding: "5px" }}
          >
            <FontAwesomeIcon icon={faThumbsDown} />
          </Button>
        </ButtonGroup>
        <div className={styles.dNumber}>{(feedbackCount > 0 ? "+" : "") + feedbackCount}</div>
      </div>
    );
  }

  renderExpandDetails() {
    const { modelGroups, data, color, model, isConsumer, updateModelFeedback, userId } = this.props;

    const segment =
      data && data.segment
        ? data.segment
        : modelGroups &&
          modelGroups.segments &&
          modelGroups.segments.find((seg) => data && seg && seg.job && seg.job.job_id === data.runId);

    const modelId = model && model.id;
    let userFeedback = 0;
    const feedbackCount =
      segment && segment.roles
        ? segment.roles.reduce((a, b) => {
            const currPref =
              b && b.preferences && b.preferences.feedback && b.preferences.feedback[modelId] !== undefined
                ? Number(b.preferences.feedback[modelId])
                : 0;
            if (b && b.role_user && b.role_user.id === Number(userId)) {
              userFeedback = currPref;
            }
            return a + currPref;
          }, 0)
        : 0;

    return (
      <div>
        <div>{this.renderModel(true)}</div>
        <div className={styles.eDrivers}>{this.renderDetails(true)}</div>
      </div>
    );
  }

  renderConsumerOverview() {
    const { id, optimized, overallSetup, setup } = this.props;

    const cSetup = optimized && optimized.setup ? optimized.setup : undefined;
    const retSetup = setup ? setup : overallSetup ? overallSetup : cSetup;

    const costs =
      retSetup && retSetup.customValues && Object.keys(retSetup.customValues).length > 0
        ? Object.keys(retSetup.customValues).map((c) => retSetup.customValues[c])
        : [retSetup.conversionGain, retSetup.conversionCost, retSetup.conversionSaved, retSetup.conversionMissed];

    return (
      <div>
        <div>{this.renderOverview()}</div>
        <div className={styles.eDrivers}>
          {costs &&
            costs.map((c, i) => (
              <div className={styles.aItem} key={"consumer-" + i}>
                {c}
              </div>
            ))}
        </div>
      </div>
    );
  }

  renderMonitorOverview() {
    const {
      id,
      projectId,
      mode,
      optimized,
      isConsumer,
      data,
      model,
      modelGroups,
      setupLabels,
      overallSetup,
      updateShowImpact,
      updateDrilldownValue,
      businessAssumptions,
      scrollToRealityHammer,
      showFeedback,
      latestData,
      segmentId,
      latestScenario,
      setup
    } = this.props;

    const rawRunId = this.props.runId;

    const overallOnly = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length < 2;

    const latestScenarioData =
      latestScenario && latestScenario[segmentId] && latestScenario[segmentId].selectedScenario;
    const latestMonitor = latestData && latestData[segmentId];

    const overallTotals = {
      leads: 0,
      opportunies: 0,
      wins: 0
    };

    latestData &&
      Object.keys(latestData).forEach((currSegmentId) => {
        const currCCM = latestData[currSegmentId] && latestData[currSegmentId].cumulativeConfusionMatrix;
        if (currCCM) {
          overallTotals.leads += currCCM.getTotal();
          overallTotals.opportunies += currCCM.getAllPositive();
          overallTotals.wins += currCCM.getTruePositive();
        }
      });

    const cSetup = optimized && optimized.setup ? optimized.setup : undefined;
    // const setup = overallSetup ? overallSetup : cSetup;

    const runId = data && data.runId;

    const sliceSetup = data && data.setup;

    const activeSlice =
      data &&
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === data.runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === data.runId)[0]
        : undefined;

    const activeColor = activeSlice ? activeSlice.color : "#7E69D7";

    const winRate =
      latestMonitor && latestMonitor.cumulativeConfusionMatrix
        ? latestMonitor.cumulativeConfusionMatrix.tp / (setup.truePositive + setup.falsePositive)
        : 0;
    const cWinRate = setup ? setup.truePositive / (setup.truePositive + setup.falsePositive) : 0;

    const cTotal = setup ? setup.truePositive + setup.falsePositive + setup.trueNegative + setup.falseNegative : 0;
    const nTotal =
      latestMonitor && latestMonitor.cumulativeConfusionMatrix
        ? latestMonitor.cumulativeConfusionMatrix.tp +
          latestMonitor.cumulativeConfusionMatrix.fp +
          latestMonitor.cumulativeConfusionMatrix.tn +
          latestMonitor.cumulativeConfusionMatrix.fn
        : 0;

    const totalRatio = (cTotal / (nTotal || 1)) * 100;

    const oldMax = Math.max(nTotal, overallTotals.leads);

    const nOpportunites =
      latestMonitor && latestMonitor.cumulativeConfusionMatrix
        ? latestMonitor.cumulativeConfusionMatrix.tp + latestMonitor.cumulativeConfusionMatrix.fp
        : 0;
    const cOpportunities = setup.truePositive + setup.falsePositive;
    const overallCOpportunities = overallSetup.truePositive + overallSetup.falsePositive;
    const opportunitiesRatio = (cOpportunities / (overallCOpportunities || 1)) * 100;

    const nWinsRaw =
      latestMonitor && latestMonitor.cumulativeConfusionMatrix ? latestMonitor.cumulativeConfusionMatrix.tp : 0;
    const cWinsRaw = setup.truePositive;
    const winsRatio = (nWinsRaw / (cWinsRaw || 1)) * 100;

    const nLeads = this.getNewFunnelValue(nTotal, oldMax);
    const nOpps = this.getNewFunnelValue(
      latestMonitor && latestMonitor.cumulativeConfusionMatrix
        ? latestMonitor.cumulativeConfusionMatrix.tp + latestMonitor.cumulativeConfusionMatrix.fp
        : 0,
      oldMax
    );

    const nWins = this.getNewFunnelValue(
      latestMonitor && latestMonitor.cumulativeConfusionMatrix ? latestMonitor.cumulativeConfusionMatrix.tp : 0,
      oldMax
    );

    const cLeads = this.getNewFunnelValue(Math.min(oldMax, cTotal), oldMax);
    const cOpps = this.getNewFunnelValue(Math.min(oldMax, cOpportunities), oldMax);
    const cWins = this.getNewFunnelValue(Math.min(oldMax, cWinsRaw), oldMax);

    const unitType = setup.unitType ? setup.unitType : "$";

    /*const isEmpty =
      cSetup.showImpact === undefined && cSetup.showBusiness === undefined;
    const isPercentage =
      cSetup.showImpact === undefined && cSetup.showBusiness === true;*/

    const isEmpty = isConsumer ? false : sliceSetup.showImpact === undefined && sliceSetup.showBusiness === undefined;
    const isPercentage = isConsumer ? false : sliceSetup.showImpact === undefined && sliceSetup.showBusiness === true;

    const cEffort = ((setup.truePositive + setup.falsePositive) / cTotal) * 100;

    const nEffort =
      latestMonitor && latestMonitor.cumulativeConfusionMatrix
        ? ((latestMonitor.cumulativeConfusionMatrix.tp + latestMonitor.cumulativeConfusionMatrix.fp) / nTotal) * 100
        : 0;

    const handleUpdateImpact = async () => {
      await updateShowImpact(runId, true);
      if (runId) {
        updateDrilldownValue(data.runId, data.value);
        if (scrollToRealityHammer) {
          scrollToRealityHammer();
        }
      }
    };

    const costDelta = activeSlice && latestScenarioData ? latestScenarioData.cost - activeSlice.currentCost : 0;

    const profitDelta = activeSlice && latestScenarioData ? latestScenarioData.profit - activeSlice.currentProfit : 0;

    const revenueDelta =
      activeSlice && latestScenarioData ? latestScenarioData.revenue - activeSlice.currentRevenue : 0;

    const profitDiffLabel = `${profitDelta > 0 ? "+" : "-"}${
      setupLabels.unitType
    }${numeral(Math.abs(profitDelta)).format("0.0a")}`;

    const revenueDiffLabel = `${revenueDelta > 0 ? "+" : "-"}${
      setupLabels.unitType
    }${numeral(Math.abs(revenueDelta)).format("0.0a")}`;

    return (
      <div className={styles.sContent}>
        <div className={styles.fullColumn}>
          {!optimized || optimized.isCreating ? (
            <div className={styles.funnelLoading}>
              <LoadingIndicator style={{ margin: "0px" }} />
            </div>
          ) : (
            <React.Fragment />
          )}
          {showFeedback && isConsumer && (
            <div className={styles.collaborateFeedback}>
              <ModelFeedbackContainer runId={rawRunId} projectId={projectId} optimized={optimized} />
            </div>
          )}
          <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
            <FunnelTooltip
              tooltipText={
                <div>
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                    </span>
                    {nTotal}
                  </div>
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Predicted " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                    </span>
                    {cTotal}
                  </div>
                </div>
              }
            >
              <div
                className={styles.modelBar}
                style={{
                  width: nLeads + "px",
                  background: activeColor,
                  opacity: 0.6
                }}
              />
            </FunnelTooltip>
            {mode === "MONITOR" && <div className={styles.monitorBar} style={{ width: cLeads + "px" }} />}
          </div>
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "700" }}>
                  {setupLabels ? setupLabels.notPursuedTransactionLabel + " " + setupLabels.falseAction + ": " : ""}
                </span>
                {latestMonitor && latestMonitor.cumulativeConfusionMatrix
                  ? latestMonitor.cumulativeConfusionMatrix.tn + latestMonitor.cumulativeConfusionMatrix.fn
                  : ""}
              </div>
            }
          >
            <div className={styles.modelBarHolder}>
              <div
                className={styles.modelBar}
                style={{
                  width: nLeads + "px",
                  borderLeft: (nLeads - nOpps) / 2 + "px solid transparent",
                  borderRight: (nLeads - nOpps) / 2 + "px dotted transparent",
                  borderTop: " 40px solid " + activeColor,
                  opacity: 0.2
                }}
              />
            </div>
          </FunnelTooltip>
          <div className={styles.modelBarHolder}>
            <FunnelTooltip
              tooltipText={
                <div>
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                    </span>
                    {nOpportunites}
                  </div>
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Predicted " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                    </span>
                    {cOpportunities}
                  </div>
                </div>
              }
            >
              <div
                className={styles.modelBar}
                style={{
                  width: nOpps + "px",
                  background: activeColor,
                  opacity: 0.8
                }}
              />
            </FunnelTooltip>
            {mode === "MONITOR" && <div className={styles.monitorBar} style={{ width: cOpps + "px" }} />}
          </div>
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "700" }}>
                  {(setupLabels ? setupLabels.transactionLabel : "") +
                    " not " +
                    (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                </span>
                {latestMonitor && latestMonitor.cumulativeConfusionMatrix
                  ? latestMonitor.cumulativeConfusionMatrix.fp
                  : ""}
              </div>
            }
          >
            <div className={styles.modelBarHolder}>
              <div
                className={styles.modelBar}
                style={{
                  width: nOpps + "px",
                  borderLeft: (nOpps - nWins) / 2 + "px solid transparent",
                  borderRight: (nOpps - nWins) / 2 + "px dotted transparent",
                  borderTop: "40px solid " + activeColor,
                  opacity: 0.3
                }}
              />
            </div>
          </FunnelTooltip>

          <div className={styles.modelBarHolder}>
            <FunnelTooltip
              tooltipText={
                <div>
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                    </span>
                    {nWinsRaw}
                  </div>
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Predicted " +
                        (setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel : "") +
                        ": "}
                    </span>
                    {cWinsRaw}
                  </div>
                </div>
              }
            >
              <div className={styles.modelBar} style={{ width: nWins + "px", background: activeColor }} />
            </FunnelTooltip>
            {mode === "MONITOR" && <div className={styles.monitorBar} style={{ width: cWins + "px" }} />}
          </div>
          {
            /*optimized && optimized.bestModel && isEmpty ? (
            <div
              className={styles.sEmpty}
              style={{ marginTop: "14px", paddingTop: "14px", height: "54psx" }}
            >
              {"Add business objectives to see the optimized effort"}
            </div>
          ) : */

            optimized && optimized.bestModel && (isPercentage || isEmpty) ? (
              <div className={styles.sInfo} style={{ marginTop: "14px", paddingTop: "14px", height: "54px" }}>
                <span className={styles.mLarge}>{nEffort.toFixed(2) + "%"}</span>
                <span className={styles.mMedium}>
                  {(nEffort > cEffort ? "+" : "-") + "(" + Math.abs(nEffort - cEffort).toFixed(2) + "%)"}
                </span>
              </div>
            ) : optimized && optimized.bestModel ? (
              <div className={styles.sInfo} style={{ marginTop: "14px", paddingTop: "14px", height: "54px" }}>
                <span className={styles.mLarge}>
                  {(latestScenarioData && latestScenarioData.cost < 0 ? "-" : "") +
                    unitType +
                    (latestScenarioData ? numeral(Math.abs(latestScenarioData.cost)).format("0.0a") : "")}
                </span>
                <span className={styles.mMedium}>
                  {`${costDelta > 0 ? "+" : "-"}${setupLabels.unitType}${numeral(Math.abs(costDelta)).format("0.0a")}`}
                </span>
              </div>
            ) : optimized ? (
              <LoadingIndicator style={{ margin: "0px" }} />
            ) : (
              <div />
            )
          }
          {optimized && optimized.bestModel && (isPercentage || isEmpty) ? (
            <div className={styles.sInfo} style={{ marginTop: "10px", paddingTop: "10px", height: "50px" }}>
              <span className={styles.mLarge}>{(winRate * 100).toFixed(2) + "%"}</span>
              <span className={styles.mMedium}>
                {(winRate * 100 > cWinRate * 100 ? "+" : "-") +
                  "(" +
                  Math.abs(winRate * 100 - cWinRate * 100).toFixed(2) +
                  "%)"}
              </span>
            </div>
          ) : optimized && optimized.bestModel ? (
            <div
              className={styles.sInfo}
              style={{
                marginTop: "10px",
                height: "50px"
              }}
            >
              <span className={styles.mLarge}>
                {(latestScenarioData && latestScenarioData.revenue < 0 ? "-" : "") +
                  unitType +
                  (latestScenarioData ? numeral(Math.abs(latestScenarioData.revenue)).format("0.0a") : "")}
              </span>
              <span className={styles.mMedium}>{revenueDiffLabel}</span>
            </div>
          ) : optimized ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <div />
          )}
          {businessAssumptions ? null : optimized && optimized.bestModel ? (
            isPercentage === true || isEmpty === true ? (
              <a
                className={styles.sEmpty}
                style={{
                  marginTop: "10px",
                  paddingTop: "10px",
                  height: "50px",
                  fontSize: "13px",
                  color: "#7E69D7"
                }}
                onClick={() => {
                  handleUpdateImpact();
                }}
              >
                <img src={LightningBoltIcon} className={styles.lightningIcon} />
                {`Review to optimize profit`}
              </a>
            ) : (
              <div
                className={styles.sInfo}
                style={{
                  marginTop: "10px",
                  paddingTop: "10px",
                  height: "50px"
                }}
              >
                <span className={styles.mLarge}>
                  {(latestScenarioData && latestScenarioData.profit < 0 ? "-" : "") +
                    unitType +
                    (latestScenarioData ? numeral(Math.abs(latestScenarioData.profit)).format("0.0a") : "")}
                </span>
                <span className={styles.mMedium}>{profitDiffLabel}</span>
                {/*
              <span className={styles.mMedium}>
                {" "}
                {optimized.profitDelta > 0
                  ? "+(" +
                    (
                      ((optimized.profit - optimized.currentProfit) /
                        optimized.profit) *
                      100
                    ).toFixed(1) +
                    "%)"
                  : "-(" +
                    (
                      ((optimized.currentProfit - optimized.profit) /
                        optimized.currentProfit) *
                      100
                    ).toFixed(1) +
                    "%)"}
              </span>
              */}
              </div>
            )
          ) : optimized ? (
            <LoadingIndicator style={{ margin: "0px" }} />
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  getComplianceRate(cPlot) {
    let retTotals = {
      complied: 0,
      notComplied: 0,
      compliedAct: 0,
      compliedNotAct: 0,
      notCompliedAct: 0,
      notCompliedNotAct: 0
    };

    cPlot &&
      cPlot.forEach((data) => {
        retTotals.complied += data.complied;
        retTotals.notComplied += data.notComplied;
        Object.keys(retTotals).forEach((k) => {
          retTotals[k] += data[k];
        });
      });

    return (
      numeral((100 * retTotals.complied) / (retTotals.complied + retTotals.notComplied || 1)).format("0.[00]") + "%"
    );
  }

  renderMonitor() {
    const { id, segmentId, runId, data, modelGroups, isDemo, projectId, compliancePlot, userCompliancePlot } =
      this.props;

    const activeSlice =
      data &&
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === data.runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === data.runId)[0]
        : undefined;

    const activeColor = activeSlice ? activeSlice.color : "#7E69D7";

    if (isDemo) {
      return (
        <div>
          <div>{this.renderOverview()}</div>
          <div className={styles.complianceHolder}>
            <div className={styles.complianceText}>{"80%"}</div>
          </div>
          <div className={styles.complianceHolder}>
            <div className={styles.complianceText}>{"90%"}</div>
          </div>
          <div className={styles.monitorGraphHolder}>
            <FakeMonitorGraph color={activeColor} />
          </div>
        </div>
      );
    }

    const overallCompliance = this.getComplianceRate(compliancePlot);
    const userCompliance = this.getComplianceRate(userCompliancePlot);

    return (
      <div>
        <div>{this.renderMonitorOverview()}</div>
        <ComplianceGraphContainer id={projectId} segmentId={segmentId} runId={runId} isMini />
        <div className={styles.monitorGraphHolder}>
          <MonitoringSparkGraphContainer color={activeColor} id={projectId} segmentId={segmentId} />
        </div>
      </div>
    );
  }

  render() {
    const { id, isConsumer, mode, data, hideSubgroup, updateDrilldownValue, clickable, businessAssumptions } =
      this.props;

    return (
      <div
        className={isConsumer ? styles.smallModelBoxConsumer : styles.smallModelBox}
        style={{
          height: isConsumer
            ? "auto"
            : mode === "DETAILS"
              ? "445px"
              : //: businessAssumptions
                //? "385px"
                "420px"
        }}
      >
        {hideSubgroup !== true && (
          <a
            className={styles.sTitle + `${clickable ? " " + styles.smallModelBoxHover : ""}`}
            style={{
              background: data.color,
              color: data.color === "#7E69D7" ? "white" : "initial"
            }}
            onClick={() => clickable && data && updateDrilldownValue(data.runId, data.value)}
          >
            {data.value}
          </a>
        )}
        {mode === "OVERVIEW" && isConsumer
          ? this.renderConsumerOverview()
          : mode === "MONITOR"
            ? this.renderMonitor()
            : mode === "OVERVIEW"
              ? this.renderOverview()
              : mode === "MODEL"
                ? this.renderModel()
                : mode === "DETAILS"
                  ? this.renderDetails()
                  : mode === "EXPAND_DETAILS"
                    ? this.renderExpandDetails()
                    : this.renderOverview()}
      </div>
    );
  }
}

class CommentItem extends React.PureComponent {
  render() {
    const { comment, deleteComment, isCreator } = this.props;

    return (
      <div className={styles.commentItemWrapper}>
        <div className={styles.commentMessage}>{comment.message}</div>
        <div className={styles.commentAuthor}>{comment.created_by ? comment.created_by.fullname : ""}</div>
        <div className={styles.commentTime}>
          {moment.utc(comment.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")}
        </div>
        <div className={styles.commentActions}>
          {isCreator && deleteComment ? <a onClick={deleteComment}>Delete</a> : ""}
        </div>
      </div>
    );
  }
}

class AddComment extends React.Component {
  state = { isEdit: Boolean(this.props.defaultOpen), commentText: "" };
  handleClose() {
    this.setState({ isEdit: false, commentText: "" });
  }
  handleOpen() {
    this.setState({ isEdit: true });
  }
  render() {
    const { postComment } = this.props;
    const { isEdit, commentText } = this.state;
    return (
      <div className={styles.addCommentWrapper}>
        <div className={styles.addCommentLink}>
          <Icon type={"chatPurple"} size={13} />
          <a onClick={() => (isEdit ? this.handleClose() : this.handleOpen())}>{"Add Comment"}</a>
        </div>
        <div className={styles.addCommentEdit + " " + (!isEdit ? styles.hide : "")}>
          <textarea
            className={styles.addCommentInput}
            placeholder={"Enter Comment"}
            value={commentText}
            onChange={(e) => this.setState({ commentText: e.target.value })}
            rows={3}
          />
          <div className={styles.addCommentButtons}>
            <Button type={"secondary"} onClick={() => this.handleClose()}>
              {"Cancel"}
            </Button>
            <Button
              style={{ marginLeft: "auto" }}
              type={"primary"}
              onClick={() => {
                this.handleClose();
                return postComment(commentText);
              }}
            >
              {"Add Comment"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
